module.exports = __webpack_public_path__ + "static/img/surveys-icon-and-name.7dd6b58.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/tools/surveys-icon-and-name.png
// module id = n6QN
// module chunks = 0